import React, { useEffect, useState } from 'react';
import { getAccessToken } from '../../../services/authService';
import SuperAdminDashboard from './SuperAdminDashboard';
import AdminLogin from '../../Login/AdminLogin';
import ScreenLoader from '../../HtmlElements/ScreenLoader';
import { useUser } from '../../../context/UserContext'; // To sync user state

const AdminRoot = () => {
    const [token, setToken] = useState(getAccessToken());
    const { user, setUser, loading } = useUser();

    // We check for token presence to decide initial view
    // If token exists, we render SuperAdminDashboard (which handles detailed auth checks)
    // If no token, we render AdminLogin

    // Handling "Auto Clear" for non-admin users trying to access admin
    const isSuperAdmin = user?.role_key === 'SUPER_ADMIN' || parseInt(user?.role) === 24;

    useEffect(() => {
        if (!loading && token && user && !isSuperAdmin) {
            // User is logged in but not an admin -> Logout/Clear session
            localStorage.removeItem('access_token');
            localStorage.removeItem('user');
            setToken(null);
            // Optionally reload to clean state if needed, but setToken(null) should switch to AdminLogin
        }
    }, [token, user, isSuperAdmin, loading]);

    const isLoggedIn = !!token && isSuperAdmin; // Only consider logged in if token AND admin role (or waiting for user load)
    // Actually, if we just set isLoggedIn based on token, the effect above will fail to clear in time for first render?
    // Let's rely on the effect to clear the token. 
    // While waiting, if user is not super admin, we should probably NOT render SuperAdminDashboard.

    if (token && loading) {
        return <ScreenLoader />;
    }

    return (
        <>
            {!!token && isSuperAdmin ? <SuperAdminDashboard /> : <AdminLogin />}
        </>
    );
};

export default AdminRoot;
